/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Create_Ai_HintInputs */

const cs_property_create_ai_hint = /** @type {(inputs: Property_Create_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI popis a překlad jsou po vytvoření dostupné na stránce nemovitosti.`)
};

const en_property_create_ai_hint = /** @type {(inputs: Property_Create_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI description and translation are available on the property page after create.`)
};

/**
* | output |
* | --- |
* | "AI description and translation are available on the property page after create." |
*
* @param {Property_Create_Ai_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_create_ai_hint = /** @type {((inputs?: Property_Create_Ai_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Create_Ai_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_create_ai_hint(inputs)
	return cs_property_create_ai_hint(inputs)
});